<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card>
    <div class="d-flex align-baseline">
      <div class="text-h3 font-weight-bold px-8">
        {{ $t('RefreshPicture') }}
      </div>
      <v-spacer />
      <v-btn
        icon
        @click="closeCard"
      >
        <v-icon large>
          mdi-close
        </v-icon>
      </v-btn>
    </div>

    <v-card-text>
      <v-container class="mb-3">
        <div>
          <div
            v-if="!isLoading"
            class="dropzone pa-8"
            @drop="drop"
          >
            <p
              style="line-height: 64px"
            >
              <v-icon>
                mdi-upload
              </v-icon>
              {{ $t('wayToUploadFile') }}
              <label
                for="imageFile"
                style="color: #3063E9; font-weight: bold; cursor: pointer"
              >{{ $t('ClickHere') }}</label>
            </p>
            <p>
              {{ $t('picProportion') }}
            </p>
            <p>{{ $t('picType') }}</p>
          </div>
          <div
            v-if="isLoading"
            class="d-flex justify-center align-center"
            style="height: 100%"
          >
            <v-progress-circular
              indeterminate
              size="60"
            />
          </div>

          <div
            v-if="isLoading"
            class="text-caption mt-6"
          >
            {{ $t('uploadTheImage') }}
          </div>
        </div>

        <input
          id="imageFile"
          ref="file"
          accept="image/*"
          style="display: none"
          type="file"
          @abort="closeCard"
          @change="onChange"
        >
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>

import { setImageUrl, uploadImage } from '@/model/dataLayer/api/takeaway/TakeawayManager'

export default {
  name: 'imgUpload.vue',
  props: {
    value: { type: Boolean },
    imgUrl: { type: String }
  },
  data () {
    return {
      activeCard: true,
      dragAndDropCapable: true,
      progress: 0,
      previewImage: this.imgUrl,
      isLoading: false,
      newImgUrl: null,
      imgFile: null
    }
  },
  watch: {
    value (val) {
      this.activeCard = val
      this.restDefault()
    }
  },
  mounted () {
  },
  methods: {
    closeCard () {
      this.restDefault()
      this.$emit('input', false)
    },
    async onChange () {
      this.isLoading = true

      this.imgFile = this.$refs.file.files[0]
      this.previewImage = URL.createObjectURL(this.imgFile)
      await this.upload(this.imgFile)

      this.closeCard()
      this.isLoading = false
    },
    drop (e) {
      e.stopPropagation()
      e.preventDefault()

      this.$refs.file.files = e.dataTransfer.files
      this.onChange()
    },

    restDefault () {
      this.previewImage = ''
      this.isLoading = false
    },

    async upload (imgFile) {
      if (imgFile) {
        this.newImgUrl = await uploadImage(imgFile)
        await setImageUrl(this.newImgUrl)

        // 反传图片URL
        this.$emit('getNewImgUrl', this.newImgUrl)
      }
    }

  }

}
</script>

<style scoped>
.dropzone {
  border: 2px dashed #90a4ae;
  border-radius: 8px;
  min-height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dropzone p {
  margin-bottom: 0;
}

.dropzone p:first-of-type {
  font-weight: 500;
  font-size: 1rem;
  color: #263238;
}

.dropzone p:first-of-type span {
  color: #62b0e8;
}

</style>
